export class Position {
  public lat!: number;
  public lng!: number;

  constructor(lng: number, lat: number) {
    this.lat = lat;
    this.lng = lng;
  }
}
